import { render } from "./SampleCode.vue?vue&type=template&id=156466ff&ts=true"
import script from "./SampleCode.vue?vue&type=script&lang=ts"
export * from "./SampleCode.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__